/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Data Sourcing Service API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { DataSourcingEnhancedRequest } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
// @ts-ignore
import type { RequestSearchFilterString } from '../../../../../../org/dataland/datalandfrontend/openApiClient/datasourcingservice/model';
/**
 * EnhancedRequestControllerApi - axios parameter creator
 */
export const EnhancedRequestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Gets all the stored data request created by the user who is making the request.
         * @summary Get all stored data requests of the user making the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequestsForRequestingUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/enhanced-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the number of requests stored in the data sourcing service, optionally filtering by company ID, data type, reporting period or state.
         * @summary Get the number of requests based on filters.
         * @param {RequestSearchFilterString} requestSearchFilterString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestCountQuery: async (requestSearchFilterString: RequestSearchFilterString, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestSearchFilterString' is not null or undefined
            assertParamExists('postRequestCountQuery', 'requestSearchFilterString', requestSearchFilterString)
            const localVarPath = `/enhanced-requests/search/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSearchFilterString, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search all requests in the data sourcing service, optionally filtering by company ID, data type, reporting period or state.
         * @summary Search requests by filters.
         * @param {RequestSearchFilterString} requestSearchFilterString 
         * @param {number} [chunkSize] 
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestSearch: async (requestSearchFilterString: RequestSearchFilterString, chunkSize?: number, chunkIndex?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestSearchFilterString' is not null or undefined
            assertParamExists('postRequestSearch', 'requestSearchFilterString', requestSearchFilterString)
            const localVarPath = `/enhanced-requests/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            if (chunkSize !== undefined) {
                localVarQueryParameter['chunkSize'] = chunkSize;
            }

            if (chunkIndex !== undefined) {
                localVarQueryParameter['chunkIndex'] = chunkIndex;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSearchFilterString, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnhancedRequestControllerApi - functional programming interface
 */
export const EnhancedRequestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EnhancedRequestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Gets all the stored data request created by the user who is making the request.
         * @summary Get all stored data requests of the user making the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRequestsForRequestingUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataSourcingEnhancedRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRequestsForRequestingUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnhancedRequestControllerApi.getRequestsForRequestingUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the number of requests stored in the data sourcing service, optionally filtering by company ID, data type, reporting period or state.
         * @summary Get the number of requests based on filters.
         * @param {RequestSearchFilterString} requestSearchFilterString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRequestCountQuery(requestSearchFilterString: RequestSearchFilterString, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRequestCountQuery(requestSearchFilterString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnhancedRequestControllerApi.postRequestCountQuery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search all requests in the data sourcing service, optionally filtering by company ID, data type, reporting period or state.
         * @summary Search requests by filters.
         * @param {RequestSearchFilterString} requestSearchFilterString 
         * @param {number} [chunkSize] 
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRequestSearch(requestSearchFilterString: RequestSearchFilterString, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataSourcingEnhancedRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRequestSearch(requestSearchFilterString, chunkSize, chunkIndex, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EnhancedRequestControllerApi.postRequestSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EnhancedRequestControllerApi - factory interface
 */
export const EnhancedRequestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EnhancedRequestControllerApiFp(configuration)
    return {
        /**
         * Gets all the stored data request created by the user who is making the request.
         * @summary Get all stored data requests of the user making the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequestsForRequestingUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourcingEnhancedRequest>> {
            return localVarFp.getRequestsForRequestingUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the number of requests stored in the data sourcing service, optionally filtering by company ID, data type, reporting period or state.
         * @summary Get the number of requests based on filters.
         * @param {RequestSearchFilterString} requestSearchFilterString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestCountQuery(requestSearchFilterString: RequestSearchFilterString, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.postRequestCountQuery(requestSearchFilterString, options).then((request) => request(axios, basePath));
        },
        /**
         * Search all requests in the data sourcing service, optionally filtering by company ID, data type, reporting period or state.
         * @summary Search requests by filters.
         * @param {RequestSearchFilterString} requestSearchFilterString 
         * @param {number} [chunkSize] 
         * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRequestSearch(requestSearchFilterString: RequestSearchFilterString, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourcingEnhancedRequest>> {
            return localVarFp.postRequestSearch(requestSearchFilterString, chunkSize, chunkIndex, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnhancedRequestControllerApi - interface
 */
export interface EnhancedRequestControllerApiInterface {
    /**
     * Gets all the stored data request created by the user who is making the request.
     * @summary Get all stored data requests of the user making the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRequestsForRequestingUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourcingEnhancedRequest>>;

    /**
     * Retrieve the number of requests stored in the data sourcing service, optionally filtering by company ID, data type, reporting period or state.
     * @summary Get the number of requests based on filters.
     * @param {RequestSearchFilterString} requestSearchFilterString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRequestCountQuery(requestSearchFilterString: RequestSearchFilterString, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * Search all requests in the data sourcing service, optionally filtering by company ID, data type, reporting period or state.
     * @summary Search requests by filters.
     * @param {RequestSearchFilterString} requestSearchFilterString 
     * @param {number} [chunkSize] 
     * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postRequestSearch(requestSearchFilterString: RequestSearchFilterString, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSourcingEnhancedRequest>>;

}

/**
 * EnhancedRequestControllerApi - object-oriented interface
 */
export class EnhancedRequestControllerApi extends BaseAPI implements EnhancedRequestControllerApiInterface {
    /**
     * Gets all the stored data request created by the user who is making the request.
     * @summary Get all stored data requests of the user making the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRequestsForRequestingUser(options?: RawAxiosRequestConfig) {
        return EnhancedRequestControllerApiFp(this.configuration).getRequestsForRequestingUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the number of requests stored in the data sourcing service, optionally filtering by company ID, data type, reporting period or state.
     * @summary Get the number of requests based on filters.
     * @param {RequestSearchFilterString} requestSearchFilterString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postRequestCountQuery(requestSearchFilterString: RequestSearchFilterString, options?: RawAxiosRequestConfig) {
        return EnhancedRequestControllerApiFp(this.configuration).postRequestCountQuery(requestSearchFilterString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search all requests in the data sourcing service, optionally filtering by company ID, data type, reporting period or state.
     * @summary Search requests by filters.
     * @param {RequestSearchFilterString} requestSearchFilterString 
     * @param {number} [chunkSize] 
     * @param {number} [chunkIndex] Only a chunk of all matching, ordered results is returned. This parameter specifies which chunk to return, starting at 0. The default value is 0, meaning the first chunk is returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postRequestSearch(requestSearchFilterString: RequestSearchFilterString, chunkSize?: number, chunkIndex?: number, options?: RawAxiosRequestConfig) {
        return EnhancedRequestControllerApiFp(this.configuration).postRequestSearch(requestSearchFilterString, chunkSize, chunkIndex, options).then((request) => request(this.axios, this.basePath));
    }
}

